import { render, staticRenderFns } from "./RegisterPage2.vue?vue&type=template&id=6338475b&scoped=true&"
import script from "./RegisterPage2.vue?vue&type=script&lang=js&"
export * from "./RegisterPage2.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPage2.vue?vue&type=style&index=0&id=6338475b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6338475b",
  null
  
)

export default component.exports